import tw, { theme } from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { NoSearchResult as NoSearchResultIcon } from '@icons/NoSearchResult';
import { Spacer } from '@components/Spacer';

const Container = tw.div`w-full h-full flex items-center justify-center mt-[50px]`;
const Content = tw.div`flex flex-col items-center justify-center`;
const Title = tw.h3`text-[18px] text-text-and-icon-muted-2`;

export const NoSearchResults = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Container>
      <Content>
        <NoSearchResultIcon fill={theme`fill.text-and-icon-muted-2`} />
        <Spacer direction='vertical' size='md' />
        <Title>{t('insights.integrations.megaphone.no_search_results.title')}</Title>
      </Content>
    </Container>
  );
};
